import {
    server
} from "@/api";

const prefix = 'api/categories'

const adminPrefix = 'api/admin/categories'

export const all = async () => {
    return await server().get(prefix + '/all')
}

export const paginate = async (data = {}) => {
    return await server().get(prefix, { params: data })
}

export const admin = {
    paginate: async (data = {}) => {
        return await server().get(adminPrefix, { params: data })
    },
    store: async (data) => {
        return await server().post(adminPrefix, data)
    },
    update: async (id, data) => {
        return await server().post(adminPrefix + '/' + id, data)
    },
    destroy: async (id) => { 
        return await server().delete(adminPrefix + '/' + id)
    }
}


const categoriesApi = {
    all,
    paginate,
    admin
}

export default categoriesApi;